//src/services/adminAuth.api.js
import { apiRequest } from "./api";

export const adminLogin = (data) => {
  return apiRequest("/admin/auth/login", {
    method: "POST",
    body: JSON.stringify(data),
  });
};